
// let options = document.querySelector('.bundle-option');
// options.addEventListener('click', function(){console.log('fuck')}, true); 

if (!customElements.get('product-bundle')) {
    customElements.define('product-bundle', class ProductBundle extends HTMLElement {
        constructor() {
            super(); 
            this.bestOption = this.querySelector('.bundle-option.best-choice');
            this.initSetup();
            this.initEvents(); 
        }

        initSetup(){
            if(this.bestOption){
                //this.selectOption(this.bestOption);
            }
        }
        initEvents(){
            if(document.body.classList.contains('product-bundle-init')) return;
            document.body.addEventListener( 'click', (e)=>{
                const target = e.target.closest(".bundle-option");
                if(target){
                    this.selectOption(target)
                    setQtyStock(target.getAttribute('ble-id'));
                    updatePaypalPay(target.getAttribute('ble-id'), this.dataset.product);
                    bundleSetPurchaseOption(target.getAttribute('ble-id'));
                }
            });
            document.body.classList.add('product-bundle-init');
        }

        selectOption(opt){
            this.options = document.querySelectorAll('product-bundle .bundle-option');
            this.priceElement = document.querySelector('product-bundle #ProductPrice span');
            this.comparepriceElement = document.querySelector('product-bundle #ComparePrice span');
            this.buyBtn = document.querySelector('product-bundle add-to-cart-btn');

            this.priceElement.innerHTML = opt.getAttribute('ble-price');
            this.comparepriceElement.innerHTML = opt.getAttribute('ble-compare-price') || '';
            this.buyBtn.setAttribute('variant', opt.getAttribute('ble-id'))
            this.options.forEach(t => t.classList.remove('selected'));
            opt.classList.add('selected');
        }
    });
}

function bundleSetPurchaseOption(variant_id) {
    const alloptions = document.querySelectorAll('product-bundle .option-container');
    alloptions.forEach(op => op.classList.remove('option-active'));
    let options = document.querySelectorAll('product-bundle purchase-options');
    let buyBtn = document.querySelector('product-bundle add-to-cart-btn');
    options.forEach(option => {
      if (option.dataset.vat == variant_id) {
        option.classList.remove('hidden');
        buyBtn.removeAttribute('plan');
        return;
      }
      return option.classList.add('hidden');
    })
}
//click bundle option container
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest("product-bundle .option-container");
    let buyBtn = document.querySelector('product-bundle add-to-cart-btn');
    if(target){
      let hasclass = target.classList.contains('option-active');
      const parent = target.closest('purchase-options');
      const options = parent.querySelectorAll('.option-container');
      options.forEach(op => op.classList.remove('option-active'));
      if (hasclass) {
        buyBtn.removeAttribute('plan');
      } else {
        buyBtn.setAttribute('plan', target.dataset.id);
        target.classList.add('option-active');
      }
    }
});





//click clasic option container
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest("form .option-container");
    if(target){
      let form = target.closest('form');
      let buyBtn = form.querySelector('add-to-cart-btn')
      let hasclass = target.classList.contains('option-active');
      const parent = target.closest('purchase-options');
      const options = parent.querySelectorAll('.option-container');
      options.forEach(op => op.classList.remove('option-active'));
      if (hasclass) {
        buyBtn.removeAttribute('plan');
      } else {
        buyBtn.setAttribute('plan', target.dataset.id);
        target.classList.add('option-active');
      }
    }
});

function variantUpdatePurchaseOption(vId, prId){
  let options = document.querySelectorAll(`purchase-options[data-prt="${ prId }" ]`);
  let form = null;
  options.forEach(opt => {
    opt.querySelectorAll('.option-container').forEach(op => op.classList.remove('option-active'))
    if(opt.dataset.vat == vId){
        form = opt.closest('form')
        return opt.classList.remove('hidden');
    }
    return opt.classList.add('hidden');
  })
  if (form) {
    from.querySelector('add-to-cart-btn').removeAttribute('plan');
  }
}
document.addEventListener('VChange', (e)=> {
    variantUpdatePurchaseOption(e.detail.variant.id, e.detail.product.id)
})


function setQtyStock(id) {
    let wrapers = document.querySelectorAll('.stock-indicator-wrapper');
    wrapers.forEach(wr => {
        if(wr.getAttribute('stock-qty') == id){
            return wr.classList.remove('hidden');
        }
        return wr.classList.add('hidden');
    })
}
document.addEventListener('VChange', (e)=> {
    setQtyStock(e.detail.variant.id);
})

function updatePaypalPay(id, pid){
    let wrapers = document.querySelectorAll('.paypal-pay');
    wrapers.forEach(wr => {
        if(wr.dataset.product == pid){
            if(wr.dataset.variant == id){
                return wr.classList.remove('hidden');
            }
            return wr.classList.add('hidden');
        }
    })
}
document.addEventListener('VChange', (e)=> {
    updatePaypalPay(e.detail.variant.id, e.detail.product.id);
})



document.addEventListener('scroll', function () {
    const box = document.querySelector('stock-level-indicator');
    if(!box) return;
    const inVew = isInViewport(box)
    if(inVew) box.classList.add('animate');

}, {
    passive: true
});
function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

// add-to-cart-btn
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest("add-to-cart-btn");
    if(target){
        let spin = target.querySelector('.fa-spin');
        let form = target.closest('form');
        let variantId = target.getAttribute('variant');
        let plan = target.getAttribute('plan');
        let qty = target.getAttribute('qty');
        let cartPopup = document.querySelector('custom-cart-drawer');
        let oldID = null;
        let oldPlan = null;
        let children = target.closest('form')?.children;
        if (children) {
            for (let child of children) {
                if (child.tagName == 'SELECT' && child.classList.contains('product-single__variants')) {
                    oldID = child.value
                }
            }
        }
      //if(form){
        //oldPlan = form.querySelector('[name="selling_plan"]')?.value
      //}

        target.classList.add('desabled');
        if(spin) spin.classList.remove('hidden');
        
        const body = JSON.stringify({
            items: [
                { 
                    quantity: qty ? parseInt(qty): 1,
                    id: oldID ? oldID : variantId,
                    selling_plan: oldPlan ? oldPlan : plan
                }
            ]
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            if(spin) spin.classList.add('hidden');
            target.classList.remove('desabled');
            if(cartPopup) return cartPopup.open();
            location.href = routes.cart_url;
        })
        .catch((e) => {
            console.error(e);
            alert('operation failed');
        })
    }
});
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest("add-to-cart-multiple");
    if(target){
        let spin = target.querySelector('.fa-spin');
        let form = target.closest('form');
        let variantIds = target.getAttribute('variants').split(',');
        let plan = target.getAttribute('plan');
        let qty = target.getAttribute('qty');
        let cartPopup = document.querySelector('custom-cart-drawer');

        let items = variantIds.map(id => {
          return {
            quantity: qty ? parseInt(qty): 1,
            id: parseInt(id),
            selling_plan: plan
          }
        })
  

        target.classList.add('desabled');
        if(spin) spin.classList.remove('hidden');
        
        const body = JSON.stringify({items});
      
        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            if(spin) spin.classList.add('hidden');
            target.classList.remove('desabled');
            if(cartPopup) return cartPopup.open();
            location.href = routes.cart_url;
        })
        .catch((e) => {
            console.error(e);
            alert('operation failed');
        })
    }
});

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

// header
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest(".mobile-nav__sublist-return .back-nav button");
    if(target){
        const parent = target.closest('.mobile-nav__sublist');
        const toggle = parent.previousElementSibling;
        toggle.classList.remove('mobile-nav--expanded');

    }
});
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest(".mobile-nav__toggle-open");
    if(target){
        const parent = target.closest('#NavDrawer');
        parent.scroll({top:0,behavior:'smooth'});

    }
});
document.body.addEventListener( 'click', (e)=>{
    const target = e.target.closest(".mobile-nav__sublist-return .mobile-menu--close-btn");
    if(target){
        document.body.classList.remove('js-drawer-open', 'js-drawer-open-left');
    }
});


class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click',this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        
        this.addEventListener('click', (event) => {
            if (event.target === this) this.hide();
        });
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
    }
}
customElements.define('modal-dialog', ModalDialog);

var VideoSellDialog = class extends ModalDialog{
    constructor() {
        super();
        this.coming_btn = this.querySelectorAll('.show-coming');
        this.coming = this.querySelector('.sell-content-section .coming-container');
        this.closeComingBtn = this.querySelector('#comingCloseButton');
        this.contentProducts = this.querySelectorAll('.sell-content-section .sproduct-card');
        this.closeBtn = this.querySelector('#goBackButton');
        this.video = this.querySelector('video');
        this.videoBtn = this.querySelector('#soundToggler');
        this.init();
    }

    init(){
        this.coming_btn.forEach(btn => {
            btn.addEventListener('click', ()=> this.coming.classList.toggle('active'));
        })
        this.closeComingBtn.addEventListener('click', ()=>this.coming.classList.remove('active'));
        this.closeBtn.addEventListener('click', ()=>this.hide());
        this.videoBtn.addEventListener('click', ()=>this.playVideo());
        this.contentProducts.forEach(pr => {
            pr.addEventListener('click', (e) => {
                if(!e.target.classList.contains('sproduct-card__link')){
                    pr.classList.toggle('collapsed');
                }
            })
        })
    }
    playVideo(){
        if(this.hasAttribute('playing')){
            this.video.pause();
            this.coming.classList.add('active')
            return this.removeAttribute('playing')
        }
        this.video.play();
        this.coming.classList.remove('active')
        return this.setAttribute('playing', true)
    }
    show(opener) {
        const modals = document.querySelectorAll('video-sell-dialog');
        modals.forEach(m => m.hide())
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
    }
    hide(){
        this.video.pause();
        this.coming.classList.add('active')
        this.removeAttribute('playing')
        super.hide();
    }
}
customElements.define('video-sell-dialog', VideoSellDialog);

var FilterDialog = class extends ModalDialog{
    constructor() {
        super();
        this.filterBtn = this.querySelectorAll('.filter-tags a');
        this.filterBtn.forEach(btn => { btn.addEventListener('click', this.hide.bind(this, false)) })
    }
}
customElements.define('product-filter-dialog', FilterDialog);

class ModalOpener extends HTMLElement {
constructor() {
    super();

    // const button = this.querySelector('button');

    // if (!button) return;
    this.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(this);
    });
}
}
customElements.define('modal-opener', ModalOpener);

class BannerSlide extends HTMLElement {
    constructor() {
        super();
        this.slidewrap = this.querySelector('.slide-top');
        this.slides = this.querySelectorAll('.bs-item');
        this.thums = this.querySelectorAll('.slider-thumb');

        this.init();
    }

    init(){
        this.initializeDesktopSliding();
    }

    initializeDesktopSliding(){
        this.thums.forEach(thumb => {
            thumb.addEventListener("mouseover", (event) => {
                this.thums.forEach(t => t.classList.remove('active'));
                thumb.classList.add('active');
                this.slides.forEach(sl => {
                    if(sl.getAttribute('index') == thumb.getAttribute('index')){
                        return sl.classList.add('active');
                    }
                    sl.classList.remove('active')
                });
            });
        })
        
    }

    mobileflick(){
    }
}
customElements.define('banner-slide', BannerSlide);

var CardSubcription = class extends HTMLElement{
    constructor() {
        super();
        this.select = this.querySelector('select[name="vid"]');
        this.button = this.querySelector('add-to-cart-btn');
        this.showMore = this.querySelector('.button_show-more');
        this.price = this.querySelector('.plan-price');
        this.init();
        
    }

    init(){
        this.select?.addEventListener('change', (e)=>{
          e.target.selectedOptions[0].getAttribute("isred");
          this.button.setAttribute('plan', e.target.selectedOptions[0].getAttribute("plan"));
          this.button.setAttribute('variant', this.select.value);
          this.price.innerHTML = e.target.selectedOptions[0].getAttribute("price");
        })
      this.showMore.addEventListener('click', (e)=>{
        let popup = document.querySelector('#sub-product-popup');
        if(popup) popup.fetch(this.showMore.dataset.handle)
      })
    }
}
customElements.define('card-subcription', CardSubcription);


class SubcriptionGridModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('.sub-product-info .content');
      this.cache = {};
    }

    fetch(handle){
      if (this.cache?.hasOwnProperty(handle)) {
        this.content.innerHTML = this.cache[handle];
        this.show();
        return;
      }
      fetch(window.Shopify.routes.root + 'products/'+handle+'?section_id=sub-product-data')
      .then(response => response.text())
      .then(html => {
        this.content.innerHTML = html;
        this.show();
        this.cache[handle] = html
      });
    }
    
}
customElements.define('sub-grid-modal', SubcriptionGridModal);

let mobilefliks = document.querySelectorAll('[mobile-data-flickity]');

function initMobileFlicks(mobilefliks) {
  mobilefliks.forEach(flick => {
    if (window.innerWidth < 768) {
      let data = JSON.parse(flick.getAttribute('mobile-data-flickity'));
      var flkty = new Flickity( flick, data);
    }else{
      var  flkty = new Flickity.data(flick);
      if(flkty) flkty.destroy();
    }
  })
}
window.addEventListener("resize", (event) => {initMobileFlicks(mobilefliks)});
window.addEventListener("DOMContentLoaded", (event) => {initMobileFlicks(mobilefliks)});

























